import { supabase } from '../supabaseClient';

export interface Post {
  id: string;
  site_id?: string;
  client_contract_id?: string | null;
  name: string;
  description: string | null;
  geofence_radius_m: number;
  location?: string;
}

export interface CreatePostParams {
  siteId: string;
  name: string;
  description?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  geofenceRadiusM?: number;
}

export const postService = {
  async getCurrentUserCompanyId(): Promise<string> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('profiles')
      .select('company_id')
      .eq('id', user.id)
      .single();

    if (error) throw error;
    return (data as { company_id: string }).company_id;
  },

  async fetchPostsBySite(siteId: string): Promise<Post[]> {
    const { data, error } = await supabase
      .from('posts')
      .select('id, site_id, client_contract_id, name, description, geofence_radius_m, location')
      .eq('site_id', siteId)
      .order('name', { ascending: true });

    if (error) throw error;
    return (data ?? []) as Post[];
  },

  async createPost({ siteId, name, description, latitude, longitude, geofenceRadiusM }: CreatePostParams): Promise<Post> {
    const companyId = await this.getCurrentUserCompanyId();
    const insertData: Record<string, unknown> = {
      company_id: companyId,
      site_id: siteId,
      name,
      description: description ?? null,
      geofence_radius_m: geofenceRadiusM ?? 50,
    };

    if (latitude != null && longitude != null) {
      insertData['location'] = `SRID=4326;POINT(${longitude} ${latitude})`;
    }

    const { data, error } = await supabase
      .from('posts')
      .insert(insertData)
      .select('id, site_id, client_contract_id, name, description, geofence_radius_m')
      .single();

    if (error) throw error;
    return data as Post;
  },

  async deletePost(postId: string): Promise<void> {
    const { error } = await supabase
      .from('posts')
      .delete()
      .eq('id', postId);

    if (error) throw error;
  },
};
